import { getProjectOntarioNews } from "./newsCoverageData.js";

function formatDate(input: string) {
  try {
    const d = new Date(input);
    return d.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
  } catch {
    return input;
  }
}

export const pressData = getProjectOntarioNews().map((n, idx) => ({
  id: n.id ?? idx + 1,
  title: n.title,
  organization: n.source,
  date: formatDate(n.publishDate),
  excerpt: n.summary,
  image: n.imageUrl,
  url: n.link,
}));
